import { StyleObj } from '@lib/interfaces/style';

function selectStyles(defaultStyles: StyleObj, classes?: StyleObj) {
  return classes && Object.keys(classes).length ? classes : defaultStyles;
}

export default selectStyles;
